




















































































































































































































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import {
  EVisitorIntegrationModel,
  EVisitorModel,
  EVisitorView,
} from "@/shared/models/eVisitor";
import { ListModel } from "@/shared/models/listModel";
import FormDescription from "@/components/misc/FormDescription.vue";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import { Notification } from "@/store/modules/notifications";
import { Action, Getter } from "vuex-class";
import { EVisitorFacilityStatus } from "@/shared/models/eVisitorFacilityStatus";
import {
  EVisitorIntegrationEnum,
  EVisitorIntegrationNameEnum,
} from "@/shared/models/enums.type";

@Component({ components: { FormDescription, RightDrawer } })
export default class EVisitorFacilitiesTable extends Vue {
  @Prop() disabled?: boolean;
  @Prop() propertyId!: number;

  allItems: EVisitorView[] = [];
  selected: EVisitorModel = new EVisitorModel();
  formOpen = false;
  isFormValid = false;
  showPassword = false;

  required(v: any) {
    return v ? true : this.$t("Validation.Required");
  }
  maxLength(max: number) {
    return (v: string) =>
      v.length <= max ? true : this.$t("Validation.MaxLength", { count: max });
  }

  @Watch("propertyId", { immediate: true })
  load() {
    if (!this.propertyId) return;

    this.axios
      .get<ListModel<EVisitorView>>(
        `properties/${this.propertyId}/eVisitorFacilities`,
        {
          params: {
            status: true,
          },
        }
      )
      .then(({ data }) => {
        this.allItems = data.result;
      });
  }

  get items() {
    return this.allItems;
  }

  headers = [
    { text: "EVisitor.Facility.Property", value: "facility" },
    { text: "Username", value: "user" },
    { text: "EVisitor.numberOfUnits", value: "numberOfUnits" },
    { text: "EVisitor.numberOfBeds", value: "numberOfBeds" },
    { text: "EVisitor.accountName", value: "accountName" },
    { text: "", value: "actions" },
  ];

  @Ref("formRef") formRef?: {
    resetValidation: () => void;
    validate: () => boolean;
  };

  rowDoubleClick(e: MouseEvent, { item }: { item: any }) {
    this.editFacility(item);
  }

  add() {
    Object.assign(this.selected, new EVisitorModel());

    this.formRef?.resetValidation();

    this.password = "";
    this.selected.propertyId = this.propertyId;

    this.formOpen = true;
  }

  saving = false;

  submit() {
    if (this.saving) {
      return;
    }

    if (!this.formRef?.validate()) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("Changes are invalid or incomplete"),
        timeout: 5000,
      });

      return;
    }

    this.saving = true;

    if (this.selected.id && this.selected.id !== 0) {
      Vue.axios
        .put("properties/editEVisitorFacility", this.selected)
        .then(() => {
          this.$store.dispatch("showNotification", {
            color: "success",
            message: this.$t("EVisitor.Facility.SaveSuccess", {
              eVisitorServiceName: this.eVisitorIntegrationName,
            }),
            timeout: 5000,
          });
          this.formOpen = false;
        })
        .finally(() => {
          this.saving = false;
          this.load();
        });
    } else {
      Vue.axios
        .post("properties/addEVisitorFacility", this.selected)
        .then(() => {
          this.$store.dispatch("showNotification", {
            color: "success",
            message: this.$t("EVisitor.Facility.SaveSuccess", {
              eVisitorServiceName: this.eVisitorIntegrationName,
            }),
            timeout: 5000,
          });

          this.formOpen = false;
        })
        .finally(() => {
          this.saving = false;
          this.load();
        });
    }
  }

  removeFacility(item: EVisitorView) {
    this.$store.dispatch("showNotification", {
      id: item.id,
      color: "warning",
      message: this.$t("EVisitor.Facility.DeleteConfirmation", {
        value: item.facility,
      }),
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.removeConfirm(item);
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    } as Notification);
  }

  removeConfirm(item: EVisitorView) {
    this.axios
      .delete<ListModel<EVisitorView>>(
        `properties/deleteEVisitorFacility/${item.id}`
      )
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("EVisitor.Facility.DeleteSuccess", {
            eVisitorServiceName: this.eVisitorIntegrationName,
          }),
          timeout: 5000,
        } as Notification);
      })
      .finally(() => {
        this.load();
      });
  }

  clearFakePass() {
    if (!this.selected.password) {
      this.selected.password = "";
    }
  }

  passwordLoading = false;
  async fetchPassword() {
    if (this.passwordLoading) return;

    this.passwordLoading = true;

    try {
      const result = await this.axios.get<{ password: string }>(
        `properties/${this.propertyId}/eVisitorFacilities/${this.selected.id}/password`
      );

      this.password = result.data.password;
      this.showPassword = true;
    } finally {
      this.passwordLoading = false;
    }
  }

  get password() {
    return this.selected.id
      ? this.selected.password ?? "******"
      : this.selected.password ?? "";
  }
  set password(val: string | null) {
    this.selected.password = val ?? "";
  }

  editFacility(item: EVisitorView) {
    this.selected.id = item.id;
    this.selected.propertyId = this.propertyId;
    this.selected.facility = item.facility;
    this.selected.user = item.user;
    this.selected.numberOfUnits = item.numberOfUnits;
    this.selected.numberOfBeds = item.numberOfBeds;
    this.selected.defaultNumberOfExtraBeds = item.defaultNumberOfExtraBeds;
    this.selected.accountName = item.accountName;
    this.selected.password = null;
    this.selected.statusId = item.statusId;
    this.showPassword = false;
    this.formOpen = true;
  }

  closeForm() {
    this.selected = new EVisitorModel();
    this.formOpen = false;
  }

  @Getter("codebooks/eVisitorFacilityStatuses")
  eVisitorFacilityStatuses?: EVisitorFacilityStatus[];
  @Action("codebooks/refreshEVisitorFacilityStatuses")
  refreshEVisitorFacilityStatuses?: () => Promise<void>;

  @Getter("appParams/tenantEVisitorIntegration")
  eVisitorIntegration?: EVisitorIntegrationModel;

  get eVisitorIntegrationName() {
    return this.eVisitorIntegration?.name ?? EVisitorIntegrationNameEnum.None;
  }

  eVisitorIntegrationEnum = EVisitorIntegrationEnum;
  get eVisitorIntegrationId() {
    return this.eVisitorIntegration?.id ?? EVisitorIntegrationEnum.None;
  }

  async created() {
    const promises = [];

    if (
      (!this.eVisitorFacilityStatuses ||
        this.eVisitorFacilityStatuses.length == 0) &&
      this.refreshEVisitorFacilityStatuses
    ) {
      promises.push(this.refreshEVisitorFacilityStatuses());
    }

    await Promise.all(promises);
  }

  mounted() {
    // add "default extra number of beds" table column for eTurizem
    if (this.eVisitorIntegrationId === EVisitorIntegrationEnum.SL) {
      const numberOfBedsIndex = this.headers.findIndex(
        (e) => e.value === "numberOfBeds"
      );
      this.headers.splice(numberOfBedsIndex + 1, 0, {
        text: "EVisitor.defaultNumberOfExtraBeds",
        value: "defaultNumberOfExtraBeds",
      });
    }
  }
}
